/**
 *  Permissions for actions on Parts
 *
 *  set*Properties are build dynamically based on the Name of the property.
 *
 *  set*Properties is permission to set property
 *  new*Properties permission to add property
 */
import * as Roles from '@/store/roles';

const partPropertiesValidate = (userRole, update) => {
  /* Subcontractors and Clients may not update any properties */
  if (userRole === Roles.SubContractor || userRole === Roles.Client) {
    return false;
  }

  /* SYS: SiteManager/SiteAssistant may NOT set these properties. */
  if (userRole === Roles.SiteManager || userRole === Roles.SiteAssistant) {
    /* update.newPartProperties.hasOwnProperty('startdate') ||
    update.newPartProperties.hasOwnProperty('expectedDonedate') || */

    if (update.newPartProperties.hasOwnProperty('calendarTime') || update.newPartProperties.hasOwnProperty('time')) {
      return false;
    }
  }

  /* SYS: SiteManager/SiteAssistant MAY set these properties. */
  if (userRole === Roles.SiteManager || userRole === Roles.SiteAssistant) {
    if (
      update.newPartProperties.hasOwnProperty('partOccupation') ||
      update.newPartProperties.hasOwnProperty('partSubcontractorId')
    ) {
      return true;
    }
  }
  return true;
};

export const partActionsPermissions = {
  addPart: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  addPartInspection: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  addSyncedPart: [Roles.Any],
  deletePart: [Roles.Admin, Roles.ProjectLeader, Roles.Trial],
  embedPartInStage: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  getPart: [Roles.Any],
  movePartBar: [Roles.Admin, Roles.ProjectLeader], // Allow moving the partBar (the whole "stage" with group of parts)
  savePartProperties: partPropertiesValidate,
  selectPart: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  setPartProperties: partPropertiesValidate,
  syncPartProperties: [Roles.Any],
};



// WEBPACK FOOTER //
// ./src/store/part/partActionsPermissions.js